import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "slots-auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slots-auth-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: "/4444logo.png",
    alt: "4444"
  })
], -1)
const _hoisted_3 = { class: "slots-auth-container" }
const _hoisted_4 = { class: "slots-auth-content" }
const _hoisted_5 = { class: "slots-auth-content-info desktop" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "slots-auth-content-form desktop" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "slots-auth-tabs" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "form-fields" }
const _hoisted_15 = { for: "phone" }
const _hoisted_16 = { class: "line-wrap" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "select-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/flags/ua.png",
      alt: ""
    })
  ])
], -1)
const _hoisted_18 = { class: "mobile-wrap" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "field-error"
}
const _hoisted_21 = { for: "phone" }
const _hoisted_22 = { class: "line-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "field-error"
}
const _hoisted_24 = { for: "password" }
const _hoisted_25 = { class: "line-wrap" }
const _hoisted_26 = { class: "under-fields" }
const _hoisted_27 = { class: "forgot-password" }
const _hoisted_28 = {
  id: "login-button",
  class: "button log-in",
  type: "submit"
}
const _hoisted_29 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_password_field = _resolveComponent("password-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_modal_description = _resolveComponent("modal-description")!
  const _component_ResetPasswordDialog = _resolveComponent("ResetPasswordDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    true
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          onSubmit: _ctx.onSubmit
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("brand.name")), 1),
                    _createElementVNode("p", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t("brand.description1")), 1),
                      _hoisted_8,
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("brand.description2")), 1)
                    ]),
                    _createElementVNode("button", {
                      id: "play-button",
                      class: "button btn-play",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.play())),
                      "data-testid": "play-button"
                    }, _toDisplayString(_ctx.$t("login.playButton")), 1),
                    _createElementVNode("button", {
                      class: "button btn-more",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = true))
                    }, _toDisplayString(_ctx.$t("login.detailsButton")), 1)
                  ], 512), [
                    [_vShow, !_ctx.showForm]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("login.title")), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([`${_ctx.$t('tabs.phone')}`, `${_ctx.$t('tabs.number')}`], (tab, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["tab-item", {active: _ctx.tabActive === index}]),
                          key: index,
                          onClick: ($event: any) => (_ctx.tabActive = index)
                        }, _toDisplayString(tab), 11, _hoisted_13))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.tabActive === 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["form-line", {'label-error': errors.phone || _ctx.customErrors.phone}])
                          }, [
                            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("login.login")), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("input", {
                                  class: "num",
                                  type: "text",
                                  value: _ctx.phoneCode,
                                  readonly: ""
                                }, null, 8, _hoisted_19),
                                _createVNode(_component_Field, {
                                  type: "tel",
                                  id: "phone",
                                  name: "phone",
                                  rules: "required",
                                  onKeydown: _ctx.onPhoneKeyDown
                                }, null, 8, ["onKeydown"]),
                                (errors.phone || _ctx.customErrors.phone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(errors.phone) + _toDisplayString(_ctx.customErrors.phone), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["form-line", {'label-error': errors.phone || _ctx.customErrors.phone}])
                          }, [
                            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("login.loginNumber")), 1),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_Field, {
                                type: "text",
                                id: "account-number",
                                name: "accountNumber",
                                rules: "required",
                                onKeydown: _ctx.onPhoneKeyDown
                              }, null, 8, ["onKeydown"]),
                              (errors.phone || _ctx.customErrors.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(errors.phone) + _toDisplayString(_ctx.customErrors.phone), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 2)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-line password", {'label-error': errors.password }])
                      }, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("login.password")), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_password_field, {
                            isConfirm: false,
                            errors: errors
                          }, null, 8, ["errors"])
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isResetPasswordDialogVisible = true), ["prevent"]))
                          }, _toDisplayString(_ctx.$t("login.forgotPassword")), 1)
                        ]),
                        _createElementVNode("button", _hoisted_28, _toDisplayString(_ctx.$t("login.submitButton")), 1)
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.showForm]
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_description, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event)),
      title: _ctx.$t('login.detailsTitle')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          innerHTML: _ctx.$t('login.details')
        }, null, 8, _hoisted_29)
      ]),
      _: 1
    }, 8, ["show", "title"]),
    (_ctx.isResetPasswordDialogVisible)
      ? (_openBlock(), _createBlock(_component_ResetPasswordDialog, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isResetPasswordDialogVisible = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}